import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTranslate } from '@repo/unicity'
import BankwireIcon from '../../assets/icons/svg/BankwireIcon.svg'

type TPaymentItem = {
    item: {
        name: string
        key: string
        icon: React.ReactNode
        subName?: React.ReactNode
    }
    isChecked: boolean
    children?: React.ReactNode
    sx?: React.CSSProperties
    onClick?: () => void
}

const BankList = [
    {
        name: 'sumitomo_mitsui_banking_corporation_marunouchi_branch',
        accountNumber: '1166789'
    },
    {
        name: 'bank_of_tokyo_mitsubishi_ufj_aoyama_branch',
        accountNumber: '4592289'
    },
    {
        name: 'yucho_bank_transfer_gaienmae_post_office',
        accountNumber: '00100 9 126835'
    }
]

const BankwireBox = ({ RowItem, isChecked, onClick }: { RowItem: React.ComponentType<TPaymentItem>; isChecked: boolean; onClick: () => void }) => {
    const { translate } = useTranslate()
    return (
        <Stack>
            <RowItem
                item={{
                    name: translate('bankwire'),
                    key: 'bankwire',
                    icon: <img src={BankwireIcon} alt="BankwireIcon" />
                }}
                isChecked={isChecked}
                onClick={onClick}
                sx={{ backgroundColor: 'rgba(244, 248, 251, 1)' }}>
                <Divider sx={{ borderColor: 'rgba(204, 222, 239, 1)', margin: '24px 0px' }} />
                <Stack
                    padding="0px"
                    paddingLeft={{
                        xs: '36px',
                        md: '51px'
                    }}>
                    <Stack direction={'column'} width={'100%'} gap={'8px'}>
                        {BankList.map(bank => (
                            <Stack direction={'row'} alignItems={'flex-start'}>
                                <Typography
                                    variant="body1"
                                    color="rgba(138, 155, 176, 1)"
                                    fontSize={{
                                        xs: '14px',
                                        sm: '16px'
                                    }}>
                                    {translate(bank.name)}
                                    {': '}
                                    <Typography
                                        variant="body3"
                                        color="#003764"
                                        fontSize={{
                                            xs: '14px',
                                            sm: '16px'
                                        }}>
                                        {bank.accountNumber}
                                    </Typography>
                                </Typography>
                                &nbsp;
                            </Stack>
                        ))}
                    </Stack>
                </Stack>
            </RowItem>
        </Stack>
    )
}

export default BankwireBox
